import { render, staticRenderFns } from "./Vereadores.vue?vue&type=template&id=ae4a7eea&scoped=true"
import script from "./Vereadores.vue?vue&type=script&lang=js"
export * from "./Vereadores.vue?vue&type=script&lang=js"
import style0 from "./Vereadores.vue?vue&type=style&index=0&id=ae4a7eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a7eea",
  null
  
)

export default component.exports